import { IS_EXPLAINER_MODAL_DISMISSED_KEY } from './isExplainerModalDismissed'

export const setIsExplainerModalDismissed = () => {
  window.localStorage.setItem(
    IS_EXPLAINER_MODAL_DISMISSED_KEY,
    JSON.stringify(true),
  )
}
